import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface PageErrorStateProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function PageErrorState({
  message = "حدث خطأ أثناء تحميل البيانات",
  onRetry,
  className,
}: PageErrorStateProps) {
  return (
    <div
      className={cn(
        "rounded-xl border border-destructive/40 bg-destructive/5 p-6 text-right",
        className,
      )}
      role="alert"
    >
      <div className="flex items-start gap-3 flex-row-reverse">
        <AlertCircle className="size-5 text-destructive shrink-0 mt-0.5" />
        <div className="flex-1 space-y-3">
          <p className="text-sm text-destructive">{message}</p>
          {onRetry && (
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              className="gap-2"
            >
              <RefreshCw className="size-3.5" />
              إعادة المحاولة
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
